import { withTranslation } from "react-i18next";
import PointSaveLogs from './PointSaveLog';

export default withTranslation()(PointSaveLogs);